/** 휴대폰 번호 입력가능한 최소 길이 */
export const MIN_PHONE_NUMBER_LENGTH = 1;

/** 휴대폰 번호 입력가능한 최대 길이 */
export const MAX_PHONE_NUMBER_LENGTH = 11;

/** 하이픈 포함한 휴대폰 번호 입력가능한 최대 길이  */
export const MAX_PHONE_NUMBER_LENGTH_WITH_HYPHEN = 13;
/** 비밀번호 입력가능한 최소 길이 */
export const MIN_PASSWORD_LENGTH = 1;

/** 비밀번호 입력가능한 최대 길이 */
export const MAX_PASSWORD_LENGTH = 20;

/** 알림창 기본 z-index */
export const ALERT_DEFAULT_ZINDEX = 1000;

/** 인증번호 타이머 초기 시간 */
export const AUTH_CODE_TIMER_INIT_TIME = 60;

/** 인증번호 입력 가능한 최대 길이 */
export const MAX_AUTH_CODE_LENGTH = 6;

/** 로그인 실패 제한 횟수 */
export const ERROR_LIMIT_COUNT = 10;

/** 닉네임 입력 가능한 최대 길이 */
export const MAX_NICKNAME_LENGTH = 8;

/** 완료 버튼 활성화를 위한 비밀번호 최소 길이 */
export const MIN_PASSWORD_LENGTH_FOR_COMPLETE = 8;

/** Pin 입력 가능한 최대 길이 */
export const MAX_PIN_LENGTH = 6;

/** Pin 입력 가능한 숫자 배열 */
export const PIN_NUMBER_ARRAY = [1, 2, 3, 4, 5, 6, 7, 8, 9];

/** 홈 화면 트랜잭션 최대 아이템 개수 */
export const MAX_TRANSACTION_ITEMS = 20;

/** 메모 입력 가능한 최대 길이 */
export const MAX_MEMO_LENGTH = 8;

/** 자산 전송 시 중복 발송을 위한 시간 체크 ms */
export const DUPLICATE_SEND_TIME = 10000;
